import React, { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';
import logoNegativo from '../../assets/jovilogo_negativo.png';
import appStore from '../../assets/appstore.png';
import googlePlay from '../../assets/google-play-badge.svg';

const Footer = () => {
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(null);
    setError(null);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${import.meta.env.VITE_URL_API}/newsletter`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : '',
        },
        body: JSON.stringify({
          emailNEWSLETTER: email,
          statusNEWSLETTER: 1
        })
      });
      if (response.status === 201) {
        setSuccess(t('footer.newsletter.success'));
        setEmail('');
      } else {
        const data = await response.json();
        setError(data?.message || t('footer.newsletter.error'));
      }
    } catch (err) {
      setError(t('footer.newsletter.connectionError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <Link to="/">
            <img src={logoNegativo} alt="JoviPlanet" className="footer-logo" />
          </Link>
          <p className="footer-description">
            {t('footer.about.description')}
          </p>
          <Link to="/about" className="footer-read-more">
            {t('footer.about.readMore')}
          </Link>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h3>{t('footer.about.title')}</h3>
            <ul>
              <li><Link to="/about">{t('footer.links.aboutUs')}</Link></li>
             {/*  <li><Link to="/plans">{t('footer.links.plans')}</Link></li> */}
              <li><Link to="/privacy-policy">{t('footer.links.privacy')}</Link></li>
              <li><Link to="/terms">{t('footer.links.terms')}</Link></li>
              <li><Link to="/cookie-policy">{t('footer.links.cookies')}</Link></li>
              <li><Link to="/complaints-book">{t('footer.links.complaints')}</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>{t('footer.help.title')}</h3>
            <ul>
              <li><Link to="/faq">{t('footer.links.faq')}</Link></li>
              <li><Link to="/contact">{t('footer.links.contact')}</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>{t('footer.tools.title')}</h3>
            <ul>
              {isLoggedIn 
                ? <li><Link to="/dashboard">{t('common.dashboard')}</Link></li>
                : <li><Link to="/login">{t('footer.links.login')}</Link></li>
              }
              <li><Link to="/register">{t('footer.links.register')}</Link></li>
              <li><Link to="/plans">{t('footer.links.prices')}</Link></li>
              <li><Link to="/agencies">{t('footer.links.agencies')}</Link></li>
              <li><Link to="https://docs.joviplanet.com/">{t('footer.links.apiDocs')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-newsletter">
          <div className="newsletter-section">
            <h3>{t('footer.newsletter.title')}</h3>
            <form onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder={t('footer.newsletter.placeholder')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
              <button type="submit" disabled={loading}>{loading ? t('contact.form.sending') : t('footer.newsletter.button')}</button>
            </form>
            {success && <p style={{ color: 'limegreen', marginTop: 8 }}>{success}</p>}
            {error && <p style={{ color: 'red', marginTop: 8 }}>{error}</p>}
          </div>

          <div className="social-section">
            <h3>{t('footer.social.title')}</h3>
            <div className="social-links">
              <a href="https://instagram.com/joviplanet" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-instagram"></i>
              </a>
              <a href="https://facebook.com/joviplanet" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-facebook"></i>
              </a>
              <a href="https://www.youtube.com/@Joviplanet" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-youtube"></i>
              </a>
              <a href="https://wa.me/joviplanet" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-whatsapp"></i>
              </a>
            </div>
          </div>

          <div className="download-section">
            <h3>{t('footer.download.title')}</h3>
            <div className="store-buttons">
              <a href="https://apps.apple.com/joviplanet" target="_blank" rel="noopener noreferrer">
                <img src={appStore} alt="Download on the App Store" />
              </a>
              <a href="https://play.google.com/store/apps/joviplanet" target="_blank" rel="noopener noreferrer">
                <img src={googlePlay} alt="Get it on Google Play" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 Joviplanet.com</p>
      </div>
    </footer>
  );
};

export default Footer; 